<div class="pv-root">

  <ng-container *ngIf="loading">
    <div class="pv-spinner-overlay">
      <mat-spinner diameter="44"></mat-spinner>
    </div>
  </ng-container>

  <div class="pv-qr-download-block" #contentToConvert id="contentToConvert">
    <img src="/assets/logo.png" alt="Qlout logo">
    <img [src]="downloadQr" alt="QR Code" class="pv-qr-download-img">
    <span *ngIf="download">{{ download?.firstName + ' ' + download?.lastName | titlecase }} ({{ download?.uniqueID }})</span>
  </div>

  <div class="pv-page" [class.pv-page--consent]="showAnalyticsConsentNotice">
    <div class="pv-topbar">
      <button class="pv-back-btn" *ngIf="user?.id" (click)="back()">
        <mat-icon>arrow_back_ios</mat-icon>
      </button>
      <h1 class="pv-page-title">Profile</h1>
    </div>

    <ng-container *ngIf="user?.isVisible == true">
      <div class="pv-banner pv-banner--info" *ngIf="showAnalyticsConsentNotice">
        <mat-icon class="pv-banner__icon">shield</mat-icon>
        <div class="pv-banner__body">
          <p>We collect limited device analytics for QR profile visits. Allow collection of device details and optional location, or deny.</p>
          <div class="pv-banner__actions">
            <button class="pv-btn pv-btn--primary" (click)="allowAnalyticsConsent()">Allow</button>
            <button class="pv-btn pv-btn--ghost" (click)="optOutAnalyticsConsent()">Deny</button>
          </div>
        </div>
      </div>

      <section class="pv-hero-card">
        <div class="pv-hero-bg"></div>
        <div class="pv-hero-content">
          <div class="pv-identity">
            <img class="pv-avatar" [src]="user?.profilePicture || 'assets/images/profilepic2.png'" loading="lazy" alt="Profile picture">
            <div class="pv-identity__text">
              <div class="pv-name">{{ user?.firstName }} {{ user?.lastName }}</div>
              <div class="pv-address-line">{{ user?.location || 'Location not shared' }}</div>
              <span class="pv-uid-badge">
                <mat-icon class="pv-uid-badge__icon">qr_code</mat-icon>
                {{ user?.uniqueID | uppercase }}
              </span>
              <div class="pv-profile-title" *ngIf="user?.title">{{ user?.title }}</div>
            </div>
          </div>
        </div>
      </section>

      <div class="pv-actions-card" *ngIf="currentUser?.role !== 'Admin'">
        <div class="pv-actions">
          <ng-container *ngIf="!userItself">
            <button class="pv-btn pv-btn--dark" *ngIf="!isFollowingUser" (click)="followButton(user)">
              <mat-icon>person_add</mat-icon> Follow
            </button>
            <button class="pv-btn pv-btn--dark" *ngIf="isFollowingUser" (click)="unfollowButton(user)">
              <mat-icon>person_remove</mat-icon> Unfollow
            </button>
            <button class="pv-btn pv-btn--outline" (qClickKeydown)="navigateChat()" *ngIf="currentUser?.role == 'User' && session?.authTokenValue">
              <mat-icon>chat_bubble_outline</mat-icon> Chat
            </button>
          </ng-container>
          <button class="pv-btn pv-btn--icon" (qClickKeydown)="openShareOptions(user)" matTooltip="Share">
            <mat-icon>share</mat-icon>
          </button>
          <button class="pv-btn pv-btn--icon pv-more-btn" [matMenuTriggerFor]="profileMenu" matTooltip="Options">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #profileMenu="matMenu">
            <button mat-menu-item (qClickKeydown)="downloadCode(user)" [disabled]="loading">
              <mat-icon>download</mat-icon>
              <span>Download QR Code</span>
            </button>
          </mat-menu>
        </div>
      </div>

         <div class="pv-banner pv-banner--warning" *ngIf="currentUser?.id !== user?.id">
        <mat-icon class="pv-banner__icon">info_outline</mat-icon>
        <p>Qlout does not verify the identity or credentials of vendors. Transact at your own discretion.</p>
      </div>

      <div class="pv-card pv-info-card">
        <div class="pv-meta-row">
          <div class="pv-chip" *ngIf="user?.isGender">
            <mat-icon class="pv-chip__icon">wc</mat-icon>
            {{ user?.gender | titlecase }}
          </div>
          <div class="pv-chip" *ngIf="user?.isBirthday">
            <mat-icon class="pv-chip__icon">cake</mat-icon>
            {{ user?.birthDate | date:'MM/dd/yyyy' }}{{ age ? ' (' + age + ' yrs)' : '' }}
          </div>
          <div class="pv-chip" *ngIf="user?.isEmail">
            <mat-icon class="pv-chip__icon">mail_outline</mat-icon>
            {{ user?.email }}
          </div>
          <div class="pv-chip" *ngIf="user?.isLocation">
            <mat-icon class="pv-chip__icon">location_on</mat-icon>
            {{ user?.location }}
          </div>
          <div class="pv-chip" *ngIf="user?.isContact">
            <mat-icon class="pv-chip__icon">phone</mat-icon>
            {{ user?.phoneNo?.internationalNumber }}
          </div>
          <img [src]="qrCode" loading="lazy" class="pv-qr-thumb" alt="QR Code">
        </div>

        <div class="pv-bio" *ngIf="user?.isBio">
          <span class="pv-bio__label">Bio</span>
          <span class="pv-bio__text">{{ user?.bio }}</span>
        </div>
      </div>

      <div class="pv-tab-bar pv-mob">
        <button class="pv-tab" [class.pv-tab--active]="activeTab === 'qtag'" (click)="activeTab = 'qtag'">
          <mat-icon>label</mat-icon> Qtag
        </button>
        <button class="pv-tab" [class.pv-tab--active]="activeTab === 'eshop'" (click)="activeTab = 'eshop'">
          <mat-icon>shopping_bag</mat-icon> E-Shop
        </button>
      </div>

      <div class="pv-listings-grid">
        <div class="pv-section-card" [class.pv-section-card--hidden]="activeTab !== 'qtag'">
          <div class="pv-section-head">
            <div class="pv-section-title">
              <mat-icon class="pv-section-title__icon">label</mat-icon> Qtag
            </div>
            <span class="pv-count-badge">{{ publicList.length }}</span>
          </div>
          <div class="pv-items-list">
            <ng-container *ngIf="publicList.length; else noQtag">
              <div class="pv-item" *ngFor="let item of publicList" (qClickKeydown)="listRoute(item)">
                <ngx-slick-carousel class="pv-item__carousel" #slickModal="slick-carousel" [config]="slideConfig" (init)="slickInit($event)" (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)" (beforeChange)="beforeChange($event)">
                  <div ngxSlickItem *ngFor="let slide of item?.photos" class="slide">
                    <img [src]="slide?.photoUrl || 'assets/images/nivia.png'" loading="lazy" class="pv-item__img" alt="Listing photo">
                  </div>
                </ngx-slick-carousel>
                <div class="pv-item__info">
                  <div class="pv-item__name">{{ item?.listing?.listingName || 'Listing' }}</div>
                  <div class="pv-item__price" *ngIf="item?.listing?.price && item?.listing?.price !== 'undefined'">CAD {{ item?.listing?.price }}</div>
                </div>
                <button class="pv-view-btn" (qClickKeydown)="listRoute(item)">View</button>
              </div>
            </ng-container>
            <ng-template #noQtag>
              <div class="pv-empty">
                <mat-icon>label_off</mat-icon>
                <span>No listings yet</span>
              </div>
            </ng-template>
          </div>
        </div>

        <div class="pv-section-card" [class.pv-section-card--hidden]="activeTab !== 'eshop'">
          <div class="pv-section-head">
            <div class="pv-section-title">
              <mat-icon class="pv-section-title__icon">shopping_bag</mat-icon> E-Shop
            </div>
            <span class="pv-count-badge">{{ list.length }}</span>
          </div>
          <div class="pv-items-list">
            <ng-container *ngIf="list.length; else noEshop">
              <div class="pv-item" *ngFor="let item of list" (qClickKeydown)="estoreRoute(item)">
                <ngx-slick-carousel class="pv-item__carousel" #slickModal="slick-carousel" [config]="slideConfig" (init)="slickInit($event)" (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)" (beforeChange)="beforeChange($event)">
                  <div ngxSlickItem *ngFor="let slide of item?.eStorePhoto" class="slide">
                    <img [src]="slide?.photoUrl || 'assets/images/nivia.png'" loading="lazy" class="pv-item__img" alt="Store photo">
                  </div>
                </ngx-slick-carousel>
                <div class="pv-item__info">
                  <div class="pv-item__name">{{ item?.eStore?.businessName || 'Store' }}</div>
                </div>
                <button class="pv-view-btn" (qClickKeydown)="estoreRoute(item)">View</button>
              </div>
            </ng-container>
            <ng-template #noEshop>
              <div class="pv-empty">
                <mat-icon>shopping_bag</mat-icon>
                <span>No shops yet</span>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="user?.isVisible == false">
      <div class="pv-private-overlay">
        <div class="pv-private-card pv-blur">
          <div class="pv-card__header">
            <div class="pv-identity">
              <img class="pv-avatar" src="assets/images/profilepic2.png" alt="Profile">
              <div class="pv-identity__text">
                <div class="pv-name">Hidden User</div>
                <span class="pv-uid-badge"><mat-icon class="pv-uid-badge__icon">qr_code</mat-icon> XXXXXX</span>
                <div class="pv-profile-title">Title</div>
              </div>
            </div>
          </div>
          <div class="pv-meta-row">
            <div class="pv-chip"><mat-icon class="pv-chip__icon">wc</mat-icon> Gender</div>
            <div class="pv-chip"><mat-icon class="pv-chip__icon">cake</mat-icon> Birthdate</div>
            <div class="pv-chip"><mat-icon class="pv-chip__icon">mail_outline</mat-icon> Email</div>
            <div class="pv-chip"><mat-icon class="pv-chip__icon">location_on</mat-icon> Location</div>
          </div>
        </div>
        <div class="pv-private-msg">
          <mat-icon class="pv-private-msg__icon">lock</mat-icon>
          <p>This profile is not visible to the public</p>
        </div>
      </div>
    </ng-container>

  </div>

  <ng-template #activatelistPopup>
    <div class="pv-modal">
      <div class="pv-modal__header">
        <h4>Warning</h4>
        <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
      </div>
      <div class="pv-modal__body">
        <p>Your Qtag has been blocked by the admin.</p>
      </div>
      <div class="pv-modal__footer">
        <button class="pv-btn pv-btn--dark" (click)="goback()">OK</button>
      </div>
    </div>
  </ng-template>

  <ng-template #activateEshopPopup>
    <div class="pv-modal">
      <div class="pv-modal__header">
        <h4>Warning</h4>
        <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
      </div>
      <div class="pv-modal__body">
        <p>Your Eshop has been blocked by the admin.</p>
      </div>
      <div class="pv-modal__footer">
        <button class="pv-btn pv-btn--dark" (click)="goback()">OK</button>
      </div>
    </div>
  </ng-template>

</div>
